import {
  GET_ALL_SCHEMES_REQUEST,
  GET_ALL_SCHEMES_SUCCESS,
  GET_ALL_SCHEMES_FAILURE,
} from "./actionTypes";

const initialState = {
  ISLOADING: false, // Fixed typo (was "ISlOADING")
  ALL_SCHEMES_LIST: [], 
  ISFAILURE: false,
};

export  function ALL_SCHEMES_LISTreducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_SCHEMES_REQUEST:
      return { ...state, ISLOADING: true }; // Fixed typo
    case GET_ALL_SCHEMES_SUCCESS:
      return {
        ...state,
        ALL_SCHEMES_LIST: payload.data, // Updated key to match SCHEMES-related data
        ISLOADING: false,
      };
    case GET_ALL_SCHEMES_FAILURE:
      return { ...state, ISFAILURE: true, ISLOADING: false };
    default:
      return state;
  }
}
